<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.construction.parts.civil_parts.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['project_drawing_civil_part_list'], ['read'])"
                        title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowClickCheck="onClickCheck"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                    >
                    </data-table>

                    <b-btn class="btn btn-dark mt-2 mr-2" @click="returnToCivilDrawings">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_civil_drawings')}}
                    </b-btn>

                    <b-btn class="btn btn-default mt-2 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_drawing_civil_part_list'], ['create'])">
                        <i class="fa fa-plus-circle mr-1"></i> {{ $t('general.part.create_button') }}
                    </b-btn>
                </b-card>
            </div>
        </div>

        <b-modal ref="saveModal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" :title="actionTitle" size="lg" @ok="saveAction" @hidden="hidden" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_drawing_civil_part_list'], ['update']))">
            <div class="row mb-3">
                <div class="col-lg-2">
                    <label>{{ $t('general.isometric.parts.search_part') }}</label>
                </div>
                <div class="col-lg-10">
                    <multiselect v-model="selectedPart"
                        :options="currentPart"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isPartLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="fullname" track-by="id"
                        :selectLabel="''"
                        @search-change="onPartSearch"
                        @input="updatePart"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedPart != null && isEdit" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedPart"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_total_qty') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.total_qty">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.total_weight') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="model.totalweight" disabled>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="5" maxlength="5000" class="form-control" v-model="model.description"></textarea>
                        </div>
                    </div>
                    
                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_material') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.material">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_size') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.size">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_thk') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.thk">
                        </div>
                    </div>
                    
                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_sizer') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.sizer">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_thkr') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.thkr">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_dimension') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.dimension">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_measureunit') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.measureunit">
                                <option v-for="measure_unit in measure_units" :value="measure_unit.code" :key="measure_unit.code">{{ measure_unit.name }}</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_unitweight') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.unitweight">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="!isEdit">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_note') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.note"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{$t('table.part_prefab_material')}}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button class="mt-1 ml-1" style="z-index: 0;" :value="false" :sync="true" :color="{checked: '#75C791', unchecked: '#dc6460'}" :labels="toggleLabels" v-model="model.prefab_material"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{$t('table.part_erection_material')}}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button class="mt-1 ml-1" style="z-index: 0;" :value="false" :sync="true" :color="{checked: '#75C791', unchecked: '#dc6460'}" :labels="toggleLabels" v-model="model.erection_material"/>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

import Multiselect from 'vue-multiselect';

export default {
    name: 'civil_drawings_parts',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.construction.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.drawings.civil_drawings.title_modal'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.parts.title'),
                    active: true
                },
            ],
            tableName: 'drawing_part',
            tableNameTranslated: Vue.i18n.translate('general.part.title'),
            actionTitle: '',
            row: null,
            tableLoaded: false,
            toggleLabels: false,
            perPage: 0,
            rowsCount: 0,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',

            selectedPart: null,
            currentPart: [],
            isPartLoading: false,

            //check if already opened
            already_opened_warning: false,
            //end check if already opened

            getData: {
                rowData: []
            },

            model: {
                description: null,
                number: null,
                material: null,
                size: null,
                sizer: null,
                thk: null,
                thkr: null,
                dimension: null,
                total_qty: null,
                measureunit: null,
                unitweight: null,
                totalweight: null,
                note: null,
                prefab_material: false,
                erection_material: false,
                revision_number: null,
                project_part_id: null,
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '90px',
                    field: '',
                    showDeleteButton: true,
                    showEditButton: true
                },
                // {
                //     label: Vue.i18n.translate('table.revision_date'),
                //     field: 'revision_date',
                //     numeric: false,
                //     html: false,
                // },
                // {
                //     label: Vue.i18n.translate('table.revision_number'),
                //     field: 'revision_number',
                //     numeric: false,
                //     html: false,
                // },
                {
                    label: Vue.i18n.translate('table.civil_work_code'),
                    field: 'drawing.civil_work_code',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.civil_work_name'),
                    field: 'drawing.civil_work_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.drawing_number'),
                    field: 'drawing.drawing_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.drawing_name'),
                    field: 'drawing.drawing_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.request'),
                    field: 'req_qty',
                    numeric: false,
                    html: false
                },
                {
                    label: Vue.i18n.translate('table.part_number'),
                    field: 'number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description'),
                    field: 'description',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material'),
                    field: 'material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_size'),
                    field: 'size',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thk'),
                    field: 'thk',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_sizer'),
                    field: 'sizer',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thkr'),
                    field: 'thkr',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_dimension'),
                    field: 'dimension',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_total_qty'),
                    field: 'total_qty',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_measureunit'),
                    field: 'measureunitV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_unitweight'),
                    field: 'unitweight',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_totalweight'),
                    field: 'totalweight',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_notes'),
                    field: 'note',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_prefab_material'),
                    field: 'prefab_material',
                    numeric: false,
                    html: false,
                    showAsCheck:true,
                },
                {
                    label: Vue.i18n.translate('table.part_erection_material'),
                    field: 'erection_material',
                    numeric: false,
                    html: false,
                    showAsCheck:true,
                }
            ]
        }
    },
    mounted () {
        this.onLoadTable();
        this.buttonYes = Vue.i18n.translate('misc.yes');
        this.buttonNo = Vue.i18n.translate('misc.no');
        this.toggleLabels = {checked: this.buttonYes, unchecked: this.buttonNo};
    },
    computed: {
        isEdit() {
            if ((this.row && typeof(this.row.id) != 'undefined') || (!this.row && this.model.project_part_id)) {
                return true;
            }

            return false;
        },
        measure_units: {
			get: function () {
				let measure_units = this.$store.getters.getMeasureUnits;
				return measure_units;
			}
		}
    },
    watch: {
		measure_units: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
		}
	},
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        warnMsg(msg) {
            miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 6000);
        },
        returnToCivilDrawings() {
            this.$router.go(-1);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route('drawing_part?drawing_id='+this.$route.params.id2 +'&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (typeof this.measure_units[field.measureunit] != 'undefined') {
                            field.measureunitV = this.measure_units[field.measureunit].name;
                        }

                        if (field.discipline_id == null) {
                            field.discipline = { 'name': '' };
                        }
                    });
                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        clearSearches () {
            this.selectedPart = null;
            this.currentPart = [];
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();

            this.model.description = null;
            this.model.number = null;
            this.model.material = null;
            this.model.size = null;
            this.model.sizer = null;
            this.model.thk = null;
            this.model.thkr = null;
            this.model.dimension = null;
            this.model.total_qty = null;
            this.model.measureunit = null;
            this.model.unitweight = null;
            this.model.totalweight = null;
            this.model.note = null;
            this.model.revision_number = null;
            this.model.prefab_material = false;
            this.model.erection_material = false;
            this.model.project_part_id = null;
            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.clearSearches();

            //check if already opened
            this.already_opened_warning = false;
            let data = {
                id: this.row.id,
                object_is_opened_now: 1,
            };
            http.route(this.tableName + '/' + this.row.id).patch(data, true).then(response => {
                if (response.isError == false) {
                    if (typeof response.data != 'undefined') {
                        if (response.data.opened_by != this.$store.state.user.user.id) {
                            this.warnMsg(Vue.i18n.translate('misc.document_is_open'));                      
                        }
                    }
                }
            });
            //end check if already opened

            this.model.description = row.description;
            this.model.number = row.number;
            this.model.material = row.material;
            this.model.size = row.size;
            this.model.sizer = row.sizer;
            this.model.thk = row.thk;
            this.model.thkr = row.thkr;
            this.model.dimension = row.dimension;
            this.model.total_qty = row.total_qty;
            this.model.measureunit = row.measureunit;
            this.model.unitweight = row.unitweight;
            this.model.totalweight = row.totalweight;
            this.model.note = row.note;
            this.model.revision_number = row.revision_number;
            this.model.prefab_material = Boolean(row.prefab_material);
            this.model.erection_material = Boolean(row.erection_material);
            if (row.project_part_id != null) {
                this.selectedPart = [{fullname: row.part.fullname, id: row.project_part_id}];
            }
            this.model.project_part_id = row.project_part_id;
            this.$refs.saveModal.show();
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                project_id: this.$route.params.id,
                drawing_id: this.$route.params.id2,
                description: this.model.description,
                number: this.model.number,
                material: this.model.material,
                size: this.model.size,
                sizer: this.model.sizer,
                thk: this.model.thk,
                thkr: this.model.thkr,
                dimension: this.model.dimension,
                total_qty: this.model.total_qty,
                measureunit: this.model.measureunit,
                unitweight: this.model.unitweight,
                totalweight: this.model.totalweight,
                note: this.model.note,
                prefab_material: this.model.prefab_material,
                erection_material: this.model.erection_material,
                project_part_id: this.model.project_part_id,
            };

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row) {
                //check if already opened
                put_data['already_opened_warning'] = this.already_opened_warning;
                //end check if already opened

                http.route(this.tableName + '/' + this.row.id).patch(put_data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.onLoadTable();

                        this.$refs.saveModal.hide();
                        //check if already opened
                        this.already_opened_warning = false;
                        //end check if already opened
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            //check if already opened
                            if (response.errorMessage[key] == 'misc.document_already_opened') {
                                this.already_opened_warning = true;
                               this.errorMsg(Vue.i18n.translate('misc.document_already_opened'));
                            } else {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            }
                            //end check if already opened
                        });
                    }
                });
            } else {
                http.route(this.tableName).post(put_data, true).then(response => {
                    if (response.isError == false) {
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if(!response.isError) {
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
						this.errorMsg(Vue.i18n.translate('errors.error_delete'));
					}
                });
            }
            this.$refs.deleteModal.hide();
        },
        onClickCheck (row, index, column) {
            if (row) {
                this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone[column.toString()] = !clone[column.toString()];

                let data = http.route(this.tableName + '/' + row.id).patch(clone, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row[column.toString()] = !row[column.toString()];
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
                this.model[column.toString()] = null;
            }
        },
        hidden(e) {
            //check if already opened
            this.already_opened_warning = false;
            if (this.row != null) {
                let data = {
                    id: this.row.id,
                    object_is_opened_now: 0,
                };
                http.route(this.tableName + '/' + this.row.id).patch(data, true);
            }
            //end check if already opened
        },
        onExportButton() {
            http.route(this.tableName).exportExcel({
                export: 'civil',
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType,
                drawing_id: this.$route.params.id2
            }, 'civil_drawing_part_list.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onPartSearch(search) {
            if (search == '') {
                this.currentPart = [];
                
                return false;
            }

            this.isPartLoading = true;
            this.searchPart(search, this);
        },
        searchPart: _.debounce((search, vm) => {
            let data = http.route('project_part?project_id='+ vm.$route.params.id +'&get_all=1&search_select=' + search + '&from_equipment=0').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentPart = response.data;
                }
                vm.isPartLoading = false;
            });
        }, 500),
        updatePart(part) {
            this.model.project_part_id = (part != null) ? part.id : null;
            if (this.model.project_part_id != null) {
                this.model.description = part.description;
            }
            
            if (this.row != null) {
                this.model.revision_number   = this.row.revision_number;
                this.model.totalweight       = this.row.totalweight;
                this.model.prefab_material   = Boolean(this.row.prefab_material);
                this.model.erection_material = Boolean(this.row.erection_material);
            }
        },
        clearSelectedPart () {
            this.model.project_part_id = null;
            this.selectedPart = null;
        },
    }
}
</script>

<style scoped>
	select {
		-webkit-appearance:menulist-button;
		-moz-appearance:menulist-button;
	}
    .multiselect-custom {
        width: 300px !important;
        height: 40px !important;
    }
    .multiselect__input:focus {
        width: 100% !important;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/pages/project/construction/drawings/civil_drawings/civil_drawings_parts.vue